
























import { Audit, Vat } from '@/api';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { vatAuditsTableFields } from './models/vat-audits-table-fields';
import ChangelogLink from '@/components/display/changelog-link.vue';

@Component({
	components: { ChangelogLink },
})
export default class MilkVatChangeLog extends Vue {
	@Prop({ required: true, type: Object })
	private readonly vat!: Vat & { audits: Audit[] };

	public get audits(): Audit[] {
		return this.vat.audits.filter((audit: Audit) => {
			const fields: string = audit.fields ?? '';
			return !fields.includes('vatOffset') && !fields.includes('calibratedAt');
		});
	}

	public get auditFields(): { key: string; label: string }[] {
		return vatAuditsTableFields;
	}
}
